var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1115 54H49.889C55.3726 54 58.7864 48.0505 56.018 43.3188L38.5802 13.5144C35.8738 8.88873 29.2122 8.81466 26.4035 13.379L8.06377 43.1834C5.15378 47.9125 8.55738 54 14.1115 54ZM29 24H35L34 38H30L29 24ZM35 43C35 44.6569 33.6569 46 32 46C30.3431 46 29 44.6569 29 43C29 41.3431 30.3431 40 32 40C33.6569 40 35 41.3431 35 43Z",
    fill: "#ABAEB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.34f684fae8e7e512311e9a8370ea885a.svg";
export { ForwardRef as ReactComponent };